module.exports = "https://cdn-skillquest.mathletics.com/app/182/assets/images/b13b44c01a0f5aea3398e9c6fee4c3db.svg";